import { View } from "@aws-amplify/ui-react";
import ProgramEventsNav from "./ProgramsEventsNav";
import { OurPrograms } from "./OurPrograms";
import { UpcomingEvents } from "./UpcomingEvents";
import { PageEnder } from "./PageEnder";

export const ProgramsEvents = () => {
  return (
    <View id="programs" className="relative flex w-full h-full flex-col">
      <div
        style={{
          backgroundImage:
            "radial-gradient(130% 100% at 0% 0%, #737373, #0C8645)",
        }}
        className="absolute h-[100%] w-full overflow-hidden"
      />
      <ProgramEventsNav />
      <OurPrograms />
      <UpcomingEvents />
      <PageEnder />
    </View>
  );
};
